module.exports = __webpack_public_path__ + "static/media/storePurchase_50_75.8589944e.png";